const quotes = [
    {
        "quote": "The greatest glory in living lies not in never falling, but in rising every time we fall.",
        "author": "Nelson Mandela"
    },
    {
        "quote": "The way to get started is to quit talking and begin doing.",
        "author": "Walt Disney"
    },
    {
        "quote": "Your time is limited, so don't waste it living someone else's life. Don't be trapped by dogma – which is living with the results of other people's thinking.",
        "author": "Steve Jobs"
    },
    {
        "quote": "Spread love everywhere you go. Let no one ever come to you without leaving happier.",
        "author": "Mother Teresa"
    },
    {
        "quote": "Don't judge each day by the harvest you reap but by the seeds that you plant.",
        "author": "Robert Louis Stevenson"
    },
    {
        "quote": "Do not go where the path may lead, go instead where there is no path and leave a trail.",
        "author": "Ralph Waldo Emerson"
    },
    {
        "quote": "Many of life's failures are people who did not realize how close they were to success when they gave up.",
        "author": "Thomas Edison"
    },
    {
        "quote": "Go confidently in the direction of your dreams! Live the life you've imagined.",
        "author": "Henry David Thoreau"
    },
    {
        "quote": "Keep smiling, because life is a beautiful thing and there's so much to smile about.",
        "author": "Marilyn Monroe"
    },
    {
        "quote": "Love the life you live. Live the life you love.",
        "author": "Bob Marley"
    },
    {
        "quote": "Your time is limited, so don't waste it living someone else's life. Don't be trapped by dogma -- which is living with the results of other people's thinking.",
        "author": "Steve Jobs"
    },
    {
        "quote": "The real test is not whether you avoid this failure, because you won't. It's whether you let it harden or shame you into inaction, or whether you learn from it; whether you choose to persevere.",
        "author": "President Barack Obama"
    },
    {
        "quote": "\"You miss 100% of the shots you don't take.\" -Wayne Gretzky",
        "author": "Michael Scott"
    },
    {
        "quote": "I have learned over the years that when one's mind is made up, this diminishes fear.",
        "author": "Rosa Parks"
    },
    {
        "quote": "I've learned that people will forget what you said, people will forget what you did, but people will never forget how you made them feel.",
        "author": "Maya Angelou"
    },
    {
        "quote": "You become what you believe.",
        "author": "Oprah Winfrey"
    },
    {
        "quote": "When everything seems to be going against you, remember that the airplane takes off against the wind, not with it.",
        "author": "Henry Ford"
    },
    {
        "quote": "I would rather die of passion than of boredom.",
        "author": "Vincent Van Gogh"
    },
    {
        "quote": "If you look at what you have in life, you'll always have more. If you look at what you don't have in life, you'll never have enough.",
        "author": "Oprah Winfrey"
    }, 
    {
        "quote": "Twenty years from now you will be more disappointed by the things that you didn't do than by the ones you did do. So, throw off the bowlines, sail away from safe harbor, catch the trade winds in your sails. Explore, Dream, Discover.",
        "author": "Mark Twain"
    }, 
    {
        "quote": "Darkness cannot drive out darkness: only light can do that. Hate cannot drive out hate: only love can do that.",
        "author": "Martin Luther King Jr."
    },
    {
        "quote": "When we strive to become better than we are, everything around us becomes better too.",
        "author": "Paulo Coelho"
    },
    {
        "quote": "In the long run, the sharpest weapon of all is a kind and gentle spirit.",
        "author": "Anne Frank"
    },
    {
        "quote": "We become not a melting pot but a beautiful mosaic. Different people, different beliefs, different yearnings, different hopes, different dreams.",
        "author": "President Jimmy Carter"
    },
    {
        "quote": "A man's true wealth is the good he does in the world.",
        "author": "Kahlil Gibran"
    },
    {
        "quote": "The successful warrior is the average man, with laser-like focus.",
        "author": "Bruce Lee"
    },
    {
        "quote": "If you don't love yourself, you cannot love others.",
        "author": "Dalai Lama"
    },
    {
        "quote": "Be yourself; everyone else is already taken.",
        "author": "Oscar Wilde"
    }, 
    {
        "quote": "No one can make you feel inferior without your consent.",
        "author": "Eleanor Roosevelt"
    },
    {
        "quote": "There are no accidents; there is only some purpose that we haven’t yet understood.",
        "author": "Deepak Chopra"
    },
    {
        "quote": "I like nonsense, it wakes up the brain cells. Fantasy is a necessary ingredient in living.",
        "author": "Dr. Seusse"
    },
    {
        "quote": "If you don’t stand for something you will fall for anything.",
        "author": "Malcolm X"
    },
    {
        "quote": "Being deeply loved by someone gives you strength, while loving someone deeply gives you courage.",
        "author": "Lao Tzu"
    },
    {
        "quote": "Every great dream begins with a dreamer. Always remember, you have within you the strength, the patience, and the passion to reach for the stars to change the world.",
        "author": "Harriet Tubman"
    },
    {
        "quote": "A man is a success if he gets up in the morning and gets to bed at night, and in between he does what he wants to do.",
        "author": "Bob Dylan"
    }
    ,
    {
        "quote": "And, when you want something, all the universe conspires in helping you to achieve it.",
        "author": "Paulo Coelho"
    },
    {
        "quote": "Oh yes, the past can hurt. But the way I see it, you can either run from it or learn from it.",
        "author": "The Lion King"
    },
    {
        "quote": "Try not to become a man of success, but rather become a man of value.",
        "author": "Albert Einstein"
    },
    {
        "quote": "Do not pray for an easy life. Pray for the strength to endure a difficult one.",
        "author": "Bruce Lee"
    },
    {
        "quote": "Most people are about as happy as they make up their minds to be.",
        "author": "Mahatma Gandhi"
    },
    {
        "quote": "Wanting to be someone else is a waste of who you are.",
        "author": "Kurt Cobain"
    }, 
    {
        "quote": "Learn from the mistakes of others. You can't live long enough to make them all yourselves.",
        "author": "Chanakya"
    }, 
    {
        "quote": "Opportunity is missed by most people because it is dressed in overalls and looks like work.",
        "author": "Thomas Edison"
    }
]

export default quotes;